import React from "react";

//import css
import classes from "./AlumniList.module.css";
import classesDark from "./AlumniListDark.module.css";

//import component
import AlumniMember from "../AlumniMember/AlumniMember";

//import DataFile
import { AlumniData } from "../AlumniData";

const AlumniList = (props) => {
  let styles = classes;
  if (props.theme) {
    styles = classes;
  } else {
    styles = classesDark;
  }

  const alumniList2020 = AlumniData.map((member) => {
    if (member.year === 2020) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  });

  const alumniList2021 = AlumniData.map((member) => {
    if (member.year === 2021) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  });

  const alumniList2022 = AlumniData.map((member) => {
    if (member.year === 2022) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  });

  const alumniList2023 = AlumniData.map((member) => {
    if (member.year === 2023) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  }); 


  const alumniList2024 = AlumniData.map((member) => {
    if (member.year === 2024) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  }); 

  const alumniList2026 = AlumniData.map((member) => {
    if (member.year === 2026) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  });

  const alumniList2025 = AlumniData.map((member) => {
    if (member.year === 2025) {
      return (
        <AlumniMember
          key={member.id}
          cardName={member.cardName}
          cardDesignation={member.cardDesignation}
          image={member.image}
          links={member.links}
          domain={member.domain}
          theme={props.theme}
        />
      );
    }
    return null;
  }); 

  return (
    <div className={styles.TeamList}>
      <div className={styles.section}>
        <h1 className={styles.teamListHeader}>Alumni</h1>
        <h2 className={styles.alumniBatchHeader}>Batch (2022-26)</h2>
        <div className={styles.listContainer}>{alumniList2026}</div>
        <h2 className={styles.alumniBatchHeader}>Batch (2021-25)</h2>
        <div className={styles.listContainer}>{alumniList2025}</div>
        <h2 className={styles.alumniBatchHeader}>Batch (2020-24)</h2>
        <div className={styles.listContainer}>{alumniList2024}</div>
        <h2 className={styles.alumniBatchHeader}>Batch (2019-23)</h2>
        <div className={styles.listContainer}>{alumniList2023}</div>
        <h2 className={styles.alumniBatchHeader}>Batch (2018-22)</h2>
        <div className={styles.listContainer}>{alumniList2022}</div>
        <h2 className={styles.alumniBatchHeader}>Batch (2017-21)</h2>
        <div className={styles.listContainer}>{alumniList2021}</div>
        <h2 className={styles.alumniBatchHeader}>Batch (2016-20)</h2>
        <div className={styles.listContainer}>{alumniList2020}</div>
      </div>
    </div>
  );
};

export default AlumniList;
